/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvidenceImageSignedUrl
 */
export interface EvidenceImageSignedUrl {
    /**
     * 
     * @type {string}
     * @memberof EvidenceImageSignedUrl
     */
    signedUrl: string;
}

/**
 * Check if a given object implements the EvidenceImageSignedUrl interface.
 */
export function instanceOfEvidenceImageSignedUrl(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;

    return isInstance;
}

export function EvidenceImageSignedUrlFromJSON(json: any): EvidenceImageSignedUrl {
    return EvidenceImageSignedUrlFromJSONTyped(json, false);
}

export function EvidenceImageSignedUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceImageSignedUrl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signedUrl': json['signed_url'],
    };
}

export function EvidenceImageSignedUrlToJSON(value?: EvidenceImageSignedUrl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signed_url': value.signedUrl,
    };
}

